/**
 * Vehicle road tax status values
 */
export enum VehicleRoadTaxStatusEnum {
	/**
	 * Vehicle road tax is pending
	 */
	PENDING = 'pending',
	/**
	 * Vehicle road tax is active
	 */
	ACTIVE = 'active',
	/**
	 * Vehicle road tax is expired
	 */
	EXPIRED = 'expired',
}
